import * as constants from "../constants/CONSTANT";
import authApi from "./authApi";

const SparkApi = {
  async handleUnauthorized(method) {
    // console.log('method', method)
    try {
      return await method();
    } catch (error) {
      if (error.response.status === 401) {
        authApi.logout();
        window.location.href = "/login";
      } else {
        console.error("Error:", error);
        throw error;
      }
    }
  },

  //shivam code fetch module for side bar
  async fetchModules(id) {
    const token = sessionStorage.getItem("token");
    return await this.handleUnauthorized(async () => {
      let response = await fetch(
        constants.API_BASE_URL + "/api/module/getmodule/" + id,
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (response.status === 401) {
        authApi.logout();
      }

      const result = await response.json();

      return result;
    });
  },

  async fetchRolePermissions(id) {
    const token = sessionStorage.getItem("token");

    try {
      const response = await fetch(
        `${constants.API_BASE_URL}/api/module/getrolepermissions/${id}`,
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      return result;
    } catch (error) {
      throw error; // Propagate error if any
    }
  },

  // --------------------------------------------------------------------------------------------------------

  async fetchDashboardRecords() {
    const token = sessionStorage.getItem("token");

    try {
      const response = await fetch(
        `${constants.API_BASE_URL}/api/productinventory/dashboards`,
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (response.status === 401) {
        authApi.logout();
        return null;
      }

      if (!response.ok) {
        return null;
      }

      const result = await response.json();

      if (result && result.success && result.records) {
        return result.records;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },

  // --------------------------------forget password by shivam shrivastava---------------
  async ForgetPasswordApi(credentials) {
    const token = sessionStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + "/api/auth/forgot-password",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(credentials),
      }
    );
    return await response.json();
  },

  async CheckOtp(email,otp) {
    const token = sessionStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + "/api/auth/check-otp",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({email,otp}),
      }
    );
    return await response.json();
  },

  // async CheckOtp(email,otp) {
  //   return await this.handleUnauthorized(async () => {
  //     const instance = getAxios();
  //     const { data } = await instance.post(
  //       `${constants.API_BASE_URL}/api/auth/check-otp`,
  //       {email,otp}
  //     );
  //     return data;
  //   });
  // },

  // --------------------------------Reset password by shivam shrivastava---------------
  async ResetPassword(email, password) {
    const token = sessionStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + "/api/auth/resetpassword/user",
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ email, password }),
      }
    );
    return await response.json();
  },


  // code Added By sarfraj

  async fetchfindallwarehouse(id) {

    const token = sessionStorage.getItem("token");

    try {
      const response = await fetch(
        `${constants.API_BASE_URL}/api/warehouse/findall/${id}`,
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      return result;
    } catch (error) {
      throw error;
    }
  },


  async fetchProductRack(id) {

    const token = sessionStorage.getItem("token");

    try {
      const response = await fetch(
        `${constants.API_BASE_URL}/api/rack/rackpro/${id}`,
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      return result;
    } catch (error) {
      throw error;
    }
  },

  async getLoginUserData() {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/auth/getuser", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    const result = await response.json();


    return result;
  },

  async fetchbarcode() {
    const token = sessionStorage.getItem("token");

    try {
      const response = await fetch(`${constants.API_BASE_URL}/api/barcode`, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {

      throw error;
    }
  },


  async imageTextOpenAI(obj) {
    const token = sessionStorage.getItem("token");
    console.log('obj-->',obj);
    try {
      const response = await fetch(
        `${constants.API_BASE_URL}/api/openai/imageToText`,
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(obj),
        }
      );
      const result = await response.json();
      return result;
    } catch (error) {      
      throw error;
    }
  },
  async fetchFiles(parentId) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/files/" + parentId + "/all",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },


  async deleteUser(id) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/auth/" + id, {
      method: "DELETE",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    return await response.json();
  },

  async updateUser(user, id) {

    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + `/api/auth/updatepassword/${id}`,
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(user),
      }
    );

    return await response.json();
  },
  //-------------saveuseer-----------
  async saveUser(user) {

    const token = sessionStorage.getItem("token");
    try {
      let response = await fetch(
        constants.API_BASE_URL + "/api/auth/saveuser",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(user),
        }
      );
      return await response.json();
    } catch (error) {
      return { success: false, message: "Error saving user" };
    }
  },
  // -------------------download file-------------------
  async downloadFiles(fileid) {

    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/files/" + fileid + "/download",
      {
        method: "GET",
        //mode: "cors",

        headers: {
          Authorization: token,
        },
      }
    );
    const fileBody = await response.blob();

    return fileBody;
  },


  //..........  Start Warehouse  by shakib khan ..........................................

  async createWarehouse(warehouse) {
    const token = sessionStorage.getItem("token");

    let response = await fetch(constants.API_BASE_URL + "/api/warehouse/", {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(warehouse),
    });
    return await response.json();
  },

  async fetchWarehouse() {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/warehouse/", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,

      },
    });

    if (response.status === 401) {
      authApi.logout();
    }

    const result = await response.json();

    return result.records;

  },

  async saveWarehouse(warehouse) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/warehouse/" + warehouse.id,
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(warehouse),
      }
    );
    return await response.json();
  },

  async fetchWarehouseById(id) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/warehouse/" + id,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,

        },
      }
    );
    const result = await response.json();

    return result;
  },

  async deleteWarehouse(id) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/warehouse/" + id,
      {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    return await response.json();
  },


  //..........  Start Rack  by shakib khan .............................................

  async fetchRacks() {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/rack/", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,

      },
    });

    if (response.status === 401) {
      authApi.logout();
    }

    const result = await response.json();
    return result;
  },

  async fetchActiveRacks() {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/rack/active", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,

      },
    });

    if (response.status === 401) {
      authApi.logout();
    }

    const result = await response.json();
    return result;
  },

  async createRack(rackRecord) {
    const token = sessionStorage.getItem("token");

    let response = await fetch(constants.API_BASE_URL + "/api/rack/", {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(rackRecord),
    });
    return await response.json();
  },

  async saveRack(rackRecord) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/rack/" + rackRecord.id,
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(rackRecord),
      }
    );


    return await response.json();
  },

  async fetchRackById(id) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/rack/" + id, {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,

      },
    });
    const result = await response.json();

    return result;
  },

  async deleteRack(id) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/rack/" + id, {
      method: "DELETE",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    return await response.json();
  },

  async fetchAllProductInventory() {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/productinventory/",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }

    const result = await response.json();

    return result;

  },

  async createProductInventory(productInventoryRecord) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/productinventory/createinventory",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(productInventoryRecord),
      }
    );
    return await response.json();
  },

  async updateProductinventory(id, data) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/productinventory/updateinventory/" + id,
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  },

  async getUpdatedFetchdata(id) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/productinventory/productup/" + id,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }

    const result = await response.json();

    return result;
  },

  async getInventoryRelatedLineItems(id) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/productinventory/getlineitems/" + id,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }

    const result = await response.json();

    return result;
  },

  async getcheckoutData(barcode) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/productinventory/checkout/" + barcode,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    return result;
  },
  async updateinventorylineitem(id, data) {

    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL +
      "/api/productinventory/updateinventorylineitem/" +
      id,
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  },
  async deleteProductInventory(id) {

    const token = sessionStorage.getItem("token");

    try {
      const response = await fetch(
        `${constants.API_BASE_URL}/api/productinventory/${id}`,
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      return await response.json();
    } catch (error) {
      throw error;
    }
  },


  async deleteinventorylineitems(id) {

    const token = sessionStorage.getItem("token");

    try {
      const response = await fetch(
        `${constants.API_BASE_URL}/api/productinventory/deleteinventorylineitems/${id}`,
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  //..........  End Product Inventory  by shakib khan ...............................................

  //..........  Start Product Category by shakib khan ...............................................

  async createProductCategory(productCategoryRecord) {
    const token = sessionStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + "/api/productcategory/",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(productCategoryRecord),
      }
    );
    return await response.json();
  },

  async saveProductCategory(productCategoryRecord) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL +
      "/api/productcategory/" +
      productCategoryRecord.id,
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(productCategoryRecord),
      }
    );
    return await response.json();
  },

  async deleteProductCategory(id) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/productcategory/" + id,
      {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    return await response.json();
  },

  //...............................End Product Category by shakib khan ...............................................


  async createProduct(product) {

    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/products", {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(product),
    });
    return await response.json();
  },

  //Added By (SHAKIB KHAN)  15-oct-24
  async getProductById(id) {

    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/products/byId/" + id,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,

        },
      }
    );
    const result = await response.json();

    return result;
  },

  async getProductCategory(data) {
    const token = sessionStorage.getItem("token");
    try {
      let response = await fetch(
        constants.API_BASE_URL + "/api/productcategory",
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      const responseData = await response.json();

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async getProducts(bracode) {
    const token = sessionStorage.getItem("token");
    try {
      let response = await fetch(constants.API_BASE_URL + "/api/products/" + bracode, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async getProductsBySearch(searchedText) {
    const token = sessionStorage.getItem("token");
    try {

      let response = await fetch(
        constants.API_BASE_URL + "/api/products/bySearch/" + searchedText,
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  },


  async updateProduct(productRecord) {
    const token = sessionStorage.getItem("token");

    try {
      let response = await fetch(
        `${constants.API_BASE_URL}/api/product/${productRecord.id}`,
        {
          method: "PUT",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(productRecord),
        }
      );

      if (!response.ok) {
        const errorResponse = await response.json();
        return {
          success: false,
          message: errorResponse.message || "Update failed",
        };
      }

      const result = await response.json();
      return { success: true, records: result };
    } catch (error) {
      return {
        success: false,
        message: "An error occurred while updating the product",
      };
    }
  },

  async deleteProduct(id) {

    const token = sessionStorage.getItem("token");
    try {
      let response = await fetch(
        `${constants.API_BASE_URL}/api/products/${id}`,
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      const responseData = await response.json();

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  //................... Create user ................................

  async createUser(user) {
    const token = sessionStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + "/api/auth/createuser",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(user),
      }
    );
    return await response.json();
  },

  // async updateUserRecord(user) {
  //   try {
  //     const token = sessionStorage.getItem("token");
  //     let response = await fetch(constants.API_BASE_URL + "/api/auth/" + user.id,
  //       {
  //         method: "PUT",
  //         mode: "cors",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: token,
  //         },
  //         body: JSON.stringify(user),
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response}`);
  //     }
  
  //     return response.json();
  //   } catch (error) {
  //     throw error;
  //   }
  // },

  //.................. save Product ............................/
  
  async updateUserRecord(user) {
    try {
        const token = sessionStorage.getItem("token");
        const response = await fetch(`${constants.API_BASE_URL}/api/auth/${user.id}`, {
            method: "PUT",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
            body: JSON.stringify(user),
        });

        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(`Message: ${errorResponse.errors || 'Unknown error'}`);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
  },
  
  async saveProduct(product) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/products/" + product.id,
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(product),
      }
    );
    return await response.json();
  },

  //................... Fetch All Products ..............................//
  async fetchProducts() {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/products", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    const result = await response.json();
    if (result.length > 0) {
      return result;
    }
    return null;
  },

  //.............. Fetch Product By Id .............................
  async fetchProduct(id) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/products/" + id, {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,

      },
    });
    const result = await response.json();

    return result;
  },

  //****************** File  *******************
  async createFile(pid, formData) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/files/" + pid, {
      method: "POST",
      mode: "cors",
      headers: {
        Authorization: token,
      },
      body: formData,
    });

    return await response.json();
  },

  //************************ files ***********************************//
  async saveFiles(file) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/files/" + file.id,
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(file),
      }
    );

    return await response.json();
  },

  async deleteFile(id) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/files/" + id, {
      method: "DELETE",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    return await response.json();
  },

  async updatefile(id) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/files/" + id, {
      method: "PUT",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    return await response.json();
  },

  // ----------------Fetch all product data- inventory-----------------
  async fetchAllProductsinventory(id) {
    try {
      const token = sessionStorage.getItem("token");

      if (!token) {
        return { success: false, message: "Authorization token missing" };
      }

      let response = await fetch(
        `${constants.API_BASE_URL}/api/productinventory/productfetchdata/${id}`,
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (!response.ok) {
        return { success: false, message: response.statusText };
      }

      return await response.json();
    } catch (error) {
      return { success: false, message: error.message };
    }
  },

  async fetchFactory() {
    const token = sessionStorage.getItem("token");

    try {
      const response = await fetch(`${constants.API_BASE_URL}/api/factories/`, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (response.status === 401) {
        authApi.logout();
        return [];
      }

      if (!response.ok) {
        return [];
      }

      const result = await response.json();

      if (result && Array.isArray(result.records)) {
        return result.records;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  },

  async fetchActiveFactory() {
    const token = sessionStorage.getItem("token");

    try {
      const response = await fetch(`${constants.API_BASE_URL}/api/factories/active`, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (response.status === 401) {
        authApi.logout();
        return [];
      }

      if (!response.ok) {
        return [];
      }

      const result = await response.json();

      if (result && Array.isArray(result.records)) {
        return result.records;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  },

  async deleteFactoryRec(id) {
    const token = sessionStorage.getItem("token");

    try {
      const response = await fetch(
        `${constants.API_BASE_URL}/api/factories/${id}`,
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async createFactoryRec(formData) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/factories", {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(formData),
    });
    return await response.json();
  },

  async updateFactoryRec(id, formData) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      `${constants.API_BASE_URL}/api/factories/${id}`,
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(formData),
      }
    );
    return await response.json();
  },

  async fetchFactoryById(id) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/factories/" + id,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    const result = await response.json();

    return result.records;
  },

  async getWarehousesTRelatedFactory(id) {
    const token = sessionStorage.getItem("token");
    try {
      let response = await fetch(
        constants.API_BASE_URL + "/api/factories/relatedwhFactory/" + id,
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      const responseData = await response.json();

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async getRelatedWarehouses(id) {
    const token = sessionStorage.getItem("token");
    try {
      let response = await fetch(
        constants.API_BASE_URL + "/api/warehouse/relatedwh/" + id,
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async getRelatedRacks(product_id, warehouse_id) {
    const token = sessionStorage.getItem("token");
    try {
      let response = await fetch(
        constants.API_BASE_URL +
        "/api/rack/relatedracks/" +
        product_id +
        "/" +
        warehouse_id,
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      const responseData = await response.json();

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async fetchUsers() {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/auth/users", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });


    const result = await response.json();

    if (result.length > 0) {
      return result;
    }
    return null;
  },

  async fetchUserById(id) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/auth/users/" + id,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    const result = await response.json();
    return result;
  },

  async reportProductFilter(filters) {
    try {
      const token = sessionStorage.getItem("token");

      const response = await fetch(
        `${constants.API_BASE_URL}/api/productinventory/reportfilter`,
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(filters),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();


      return result;
    } catch (error) {
      throw error;
    }
  },

  async reportDetailsFilter(filters) {
    try {
      const token = sessionStorage.getItem("token");

      const response = await fetch(
        `${constants.API_BASE_URL}/api/productinventory/reportdetails`,
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(filters),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();


      return result;
    } catch (error) {
      throw error;
    }
  },

  async fetchScannedProductDetails(barcode) {
    try {
      const token = sessionStorage.getItem("token");
      let response = await fetch(
        constants.API_BASE_URL + "/api/productinventory/product/" + barcode,
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      const result = await response.json();
      return result;
    } catch (error) {
      throw error;
    }
  },

  async saveCompressedImage(gallaryFile) {
    try {
      const formData = new FormData();
      formData.append("image", gallaryFile);

      const token = sessionStorage.getItem("token");
      let response = await fetch(
        constants.API_BASE_URL + "/api/gallary",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: token,
          },
          body: formData,
        }
      );
      const result = await response.json();
      return result;
    } catch (error) {
      throw error;
    }
  },

  async upsertRolePermissions(permissionsData) {
    const token = sessionStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/module",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(permissionsData),
      }
    );
    const result = await response.json();
    return result;
  },

  async updateUserProfile(body , id){
    try {
      const token = sessionStorage.getItem("token");
      let response = await fetch(
        `${constants.API_BASE_URL}/api/auth/editprofile/${id}`,
        {
          method: "PUT",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(body),
        }
      );
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

};
export default SparkApi;
